var magicStyles = [".description[data-v-1e790a54]{text-align:center;margin:0 auto var(--magic-space,16px)}.action[data-v-1e790a54]{margin:0 auto;width:100%}@media (min-width:500px){.action[data-v-1e790a54]{max-width:var(--magic-element-default-width,288px)}}"];

export default magicStyles;
